export type CaptionStep = {
  text: string;
  /** 表示開始までの遅延 ms。 */
  atMs: number;
  /** 表示を畳むまでの時間 ms。 */
  durationMs: number;
};

export const RESHUFFLE_CAPTION = "山札が足りないため捨て札をシャッフルして山札に戻した。";
export const DRAW_CAPTION = "山札から手札を引いた。";

/** リシャッフル演出の長さ（docs/reshuffle_animation.md 参照）。 */
export const RESHUFFLE_MS = 1400;
const DEAL_STAGGER_MS = 70;
const DEAL_ANIM_MS = 350;
const CAPTION_LINGER_MS = 1500;

/**
 * プレイ画面のメッセージゾーンに出すキャプションの並びを返す。
 * リシャッフル直後は「混ぜて戻した」→「引いた」の順。引くだけなら「引いた」のみ。
 */
export function captionSchedule(reshuffled: boolean, dealtCount: number): CaptionStep[] {
  if (dealtCount === 0) return [];
  const dealEndMs = (dealtCount - 1) * DEAL_STAGGER_MS + DEAL_ANIM_MS;
  if (!reshuffled) {
    return [{ text: DRAW_CAPTION, atMs: 0, durationMs: dealEndMs + CAPTION_LINGER_MS }];
  }
  return [
    { text: RESHUFFLE_CAPTION, atMs: 0, durationMs: RESHUFFLE_MS },
    { text: DRAW_CAPTION, atMs: RESHUFFLE_MS, durationMs: dealEndMs + CAPTION_LINGER_MS },
  ];
}
